import useTheme from '@mui/material/styles/useTheme';
import MetaTags from 'react-helmet';
import { type CustomTheme } from '../provider/ThemeProvider';
import { LEAD } from '../vars';

type MetaProps = {
    title?: string;
};

function Meta(props: MetaProps) {
    const theme: CustomTheme = useTheme();
    const title = (props.title ? props.title + ' - AHD Cars' : 'AHD Cars') + (!LEAD ? ' Support' : '');
    const color = theme?.palette?.primary?.main;

    return (
        <MetaTags>
            <title>{title}</title>
            <meta property="og:title" content={title} />
            <link rel="icon" type="image/png" href="/favicon/favicon-96x96.png" sizes="96x96" />
            <link rel="icon" type="image/svg+xml" href="/favicon/favicon.svg" />
            <link rel="shortcut icon" href="/favicon/favicon.ico" />
            <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
            <meta name="apple-mobile-web-app-title" content="AHD Cars" />
            <link rel="manifest" href="/favicon/site.webmanifest" />
            <meta name="theme-color" content={color} />
        </MetaTags>
    );
}

export default Meta;
